var SupportNowStatusAndNotesPresentation;

SupportNowStatusAndNotesPresentation = {
  editable: {
    status: "Can be edited until <span class='localtime'>{{editable_deadline}}</span>",
    notes: "You can edit this order until <span class='longlocaltime'>{{editable_deadline}}</span>. " + I18n.translate('js.modules.notes.editable_notes_message')
  },
  not_editable: {
    purchased: {
      status: "Ready to print",
      notes: I18n.translate('js.modules.notes.not_editable_notes_message')
    },
    redeemed: {
      status: "Used on <span class='localtime'>{{redeemed_date}}</span>",
      notes: ""
    },
    available: {
      status: "Ready to print",
      notes: I18n.translate('js.modules.notes.not_editable_notes_message')
    },
    expired: {
      status: "Expired",
      notes: ""
    },
    expired_unredeemed: {
      status: "Promotional value expired on <span class='utctime'>{{expiration_date}}</span>",
      notes: I18n.translate('js.modules.notes.not_editable_expired_unredeemed_message') + ", you can still redeem it at <strong>{{merchant_name}}</strong> for the amount you paid for it."
    },
    expired_redeemed: {
      status: "Used on <span class='localtime'>{{redeemed_date}}</span>",
      notes: ""
    }
  }
};

module.exports = SupportNowStatusAndNotesPresentation;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvcHJlc2VudGVycy9ub3dfbWVzc2FnZXMuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvcHJlc2VudGVycy9ub3dfbWVzc2FnZXMuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsb0NBQUEsR0FDQztFQUFBLFFBQUEsRUFDQztJQUFBLE1BQUEsRUFBUSwwRUFBUjtJQUNBLEtBQUEsRUFBTywwRkFBQSxHQUE2RixJQUFJLENBQUMsU0FBTCxDQUFlLHlDQUFmLENBRHBHO0dBREQ7RUFHQSxZQUFBLEVBQ0M7SUFBQSxTQUFBLEVBQ0M7TUFBQSxNQUFBLEVBQVEsZ0JBQVI7TUFDQSxLQUFBLEVBQU8sSUFBSSxDQUFDLFNBQUwsQ0FBZSw2Q0FBZixDQURQO0tBREQ7SUFHQSxRQUFBLEVBQ0M7TUFBQSxNQUFBLEVBQVEsMERBQVI7TUFDQSxLQUFBLEVBQU8sRUFEUDtLQUpEO0lBTUEsU0FBQSxFQUNDO01BQUEsTUFBQSxFQUFRLGdCQUFSO01BQ0EsS0FBQSxFQUFPLElBQUksQ0FBQyxTQUFMLENBQWUsNkNBQWYsQ0FEUDtLQVBEO0lBU0EsT0FBQSxFQUNDO01BQUEsTUFBQSxFQUFRLFNBQVI7TUFDQSxLQUFBLEVBQU8sRUFEUDtLQVZEO0lBWUEsa0JBQUEsRUFDQztNQUFBLE1BQUEsRUFBUSwrRUFBUjtNQUNBLEtBQUEsRUFBUSxJQUFJLENBQUMsU0FBTCxDQUFlLDBEQUFmLENBQUEsR0FBNkUsaUdBRHJGO0tBYkQ7SUFlQSxnQkFBQSxFQUNDO01BQUEsTUFBQSxFQUFRLDBEQUFSO01BQ0EsS0FBQSxFQUFPLEVBRFA7S0FoQkQ7R0FKRDs7O0FBdUJELE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
